import {IAmplitudeItemListContext} from "../../../../tracking/amplitude/get_amplitude_view_item_event_properties";
import {PENDING_DETAIL_CONTEXT_LOCAL_STORAGE_KEY, PENDING_DETAIL_CONTEXT_TTL_MS} from "./offer_listing_amplitude_item_list_storage_keys";

const PENDING_DETAIL_CONTEXT_URL_PARAM = "_amp_list_ctx";

export interface IOfferListingAmplitudePendingDetailContext {
    itemListId: string;
    itemListName?: IAmplitudeItemListContext["itemListName"];
    itemId: number;
    propertyId?: number;
    expiresAt: number;
}

type PendingDetailContextsByToken = Record<string, IOfferListingAmplitudePendingDetailContext>;

export const createOfferListingAmplitudePendingDetailUrl = (params: {
    url: string;
    itemId: number;
    propertyId?: number;
    itemListContext?: IAmplitudeItemListContext | null;
    now?: number;
}): string => {
    const {url, itemId, propertyId, itemListContext, now = Date.now()} = params;

    if (!itemListContext?.itemListId) {
        return url;
    }

    const token = createPendingDetailContextToken();
    writeStoredPendingDetailContexts({
        ...readValidStoredPendingDetailContexts(now),
        [token]: {
            itemId,
            propertyId,
            itemListId: itemListContext.itemListId,
            itemListName: itemListContext.itemListName,
            expiresAt: now + PENDING_DETAIL_CONTEXT_TTL_MS
        }
    });

    return addPendingDetailContextTokenToUrl(url, token);
};

export const takeOfferListingAmplitudePendingDetailContext = (params: {
    itemId: number;
    propertyId?: number | null;
    now?: number;
}): IAmplitudeItemListContext | null => {
    const {itemId, propertyId, now = Date.now()} = params;
    const token = getPendingDetailContextTokenFromUrl();

    if (!token) {
        return null;
    }

    removePendingDetailContextTokenFromUrl();

    const pendingContexts = readStoredPendingDetailContexts();
    const pendingContext = pendingContexts[token];

    if (!pendingContext) {
        return null;
    }

    const nextPendingContexts = {...pendingContexts};
    delete nextPendingContexts[token];
    writeStoredPendingDetailContexts(nextPendingContexts);

    const propertyMatches = pendingContext.propertyId != null ? pendingContext.propertyId === propertyId : propertyId == null;

    if (pendingContext.expiresAt < now || pendingContext.itemId !== itemId || !propertyMatches) {
        return null;
    }

    return {
        itemListId: pendingContext.itemListId,
        itemListName: pendingContext.itemListName
    };
};

const createPendingDetailContextToken = (): string => {
    if (typeof crypto !== "undefined" && crypto.randomUUID) {
        return crypto.randomUUID();
    }

    return `${Date.now()}-${Math.random().toString(16).slice(2)}`;
};

const addPendingDetailContextTokenToUrl = (url: string, token: string): string => {
    const urlObject = new URL(url, getUrlBase());
    urlObject.searchParams.set(PENDING_DETAIL_CONTEXT_URL_PARAM, token);

    if (isAbsoluteUrl(url)) {
        return urlObject.toString();
    }

    return `${urlObject.pathname}${urlObject.search}${urlObject.hash}`;
};

const getPendingDetailContextTokenFromUrl = (): string | null => {
    if (typeof window === "undefined") {
        return null;
    }

    return new URL(window.location.href).searchParams.get(PENDING_DETAIL_CONTEXT_URL_PARAM);
};

const removePendingDetailContextTokenFromUrl = () => {
    if (typeof window === "undefined") {
        return;
    }

    const url = new URL(window.location.href);

    if (!url.searchParams.has(PENDING_DETAIL_CONTEXT_URL_PARAM)) {
        return;
    }

    url.searchParams.delete(PENDING_DETAIL_CONTEXT_URL_PARAM);
    window.history.replaceState(window.history.state, "", `${url.pathname}${url.search}${url.hash}`);
};

const readValidStoredPendingDetailContexts = (now: number): PendingDetailContextsByToken => {
    const pendingContexts = readStoredPendingDetailContexts();

    return Object.fromEntries(Object.entries(pendingContexts).filter(([, pendingContext]) => pendingContext.expiresAt >= now));
};

const readStoredPendingDetailContexts = (): PendingDetailContextsByToken => {
    if (!isLocalStorageSupported()) {
        return {};
    }

    try {
        const rawValue = window.localStorage.getItem(PENDING_DETAIL_CONTEXT_LOCAL_STORAGE_KEY);
        return rawValue ? JSON.parse(rawValue) : {};
    } catch {
        return {};
    }
};

const writeStoredPendingDetailContexts = (pendingContexts: PendingDetailContextsByToken) => {
    if (!isLocalStorageSupported()) {
        return;
    }

    const tokens = Object.keys(pendingContexts);

    try {
        if (tokens.length === 0) {
            window.localStorage.removeItem(PENDING_DETAIL_CONTEXT_LOCAL_STORAGE_KEY);
            return;
        }

        window.localStorage.setItem(PENDING_DETAIL_CONTEXT_LOCAL_STORAGE_KEY, JSON.stringify(pendingContexts));
    } catch {
        return;
    }
};

const isLocalStorageSupported = () => {
    return typeof window !== "undefined" && "localStorage" in window;
};

const getUrlBase = (): string => {
    return typeof window !== "undefined" ? window.location.origin : "https://www.rynekpierwotny.pl";
};

const isAbsoluteUrl = (url: string): boolean => /^[a-z][a-z\d+\-.]*:\/\//i.test(url);
import {IAmplitudeItemListContext} from "../../../../tracking/amplitude/get_amplitude_view_item_event_properties";
import {PENDING_DETAIL_CONTEXT_LOCAL_STORAGE_KEY, PENDING_DETAIL_CONTEXT_TTL_MS} from "./offer_listing_amplitude_item_list_storage_keys";

const PENDING_DETAIL_CONTEXT_URL_PARAM = "_amp_list_ctx";

export interface IOfferListingAmplitudePendingDetailContext {
    itemListId: string;
    itemListName?: IAmplitudeItemListContext["itemListName"];
    itemId: number;
    propertyId?: number;
    expiresAt: number;
}

type PendingDetailContextsByToken = Record<string, IOfferListingAmplitudePendingDetailContext>;

export const createOfferListingAmplitudePendingDetailUrl = (params: {
    url: string;
    itemId: number;
    propertyId?: number;
    itemListContext?: IAmplitudeItemListContext | null;
    now?: number;
}): string => {
    const {url, itemId, propertyId, itemListContext, now = Date.now()} = params;

    if (!itemListContext?.itemListId) {
        return url;
    }

    const token = createPendingDetailContextToken();
    writeStoredPendingDetailContexts({
        ...readValidStoredPendingDetailContexts(now),
        [token]: {
            itemId,
            propertyId,
            itemListId: itemListContext.itemListId,
            itemListName: itemListContext.itemListName,
            expiresAt: now + PENDING_DETAIL_CONTEXT_TTL_MS
        }
    });

    return addPendingDetailContextTokenToUrl(url, token);
};

export const takeOfferListingAmplitudePendingDetailContext = (params: {
    itemId: number;
    propertyId?: number | null;
    now?: number;
}): IAmplitudeItemListContext | null => {
    const {itemId, propertyId, now = Date.now()} = params;
    const token = getPendingDetailContextTokenFromUrl();

    if (!token) {
        return null;
    }

    removePendingDetailContextTokenFromUrl();

    const pendingContexts = readStoredPendingDetailContexts();
    const pendingContext = pendingContexts[token];

    if (!pendingContext) {
        return null;
    }

    const nextPendingContexts = {...pendingContexts};
    delete nextPendingContexts[token];
    writeStoredPendingDetailContexts(nextPendingContexts);

    const propertyMatches = pendingContext.propertyId != null ? pendingContext.propertyId === propertyId : propertyId == null;

    if (pendingContext.expiresAt < now || pendingContext.itemId !== itemId || !propertyMatches) {
        return null;
    }

    return {
        itemListId: pendingContext.itemListId,
        itemListName: pendingContext.itemListName
    };
};

const createPendingDetailContextToken = (): string => {
    if (typeof crypto !== "undefined" && crypto.randomUUID) {
        return crypto.randomUUID();
    }

    return `${Date.now()}-${Math.random().toString(16).slice(2)}`;
};

const addPendingDetailContextTokenToUrl = (url: string, token: string): string => {
    const urlObject = new URL(url, getUrlBase());
    urlObject.searchParams.set(PENDING_DETAIL_CONTEXT_URL_PARAM, token);

    if (isAbsoluteUrl(url)) {
        return urlObject.toString();
    }

    return `${urlObject.pathname}${urlObject.search}${urlObject.hash}`;
};

const getPendingDetailContextTokenFromUrl = (): string | null => {
    if (typeof window === "undefined") {
        return null;
    }

    return new URL(window.location.href).searchParams.get(PENDING_DETAIL_CONTEXT_URL_PARAM);
};

const removePendingDetailContextTokenFromUrl = () => {
    if (typeof window === "undefined") {
        return;
    }

    const url = new URL(window.location.href);

    if (!url.searchParams.has(PENDING_DETAIL_CONTEXT_URL_PARAM)) {
        return;
    }

    url.searchParams.delete(PENDING_DETAIL_CONTEXT_URL_PARAM);
    window.history.replaceState(window.history.state, "", `${url.pathname}${url.search}${url.hash}`);
};

const readValidStoredPendingDetailContexts = (now: number): PendingDetailContextsByToken => {
    const pendingContexts = readStoredPendingDetailContexts();

    return Object.fromEntries(Object.entries(pendingContexts).filter(([, pendingContext]) => pendingContext.expiresAt >= now));
};

const readStoredPendingDetailContexts = (): PendingDetailContextsByToken => {
    if (!isLocalStorageSupported()) {
        return {};
    }

    try {
        const rawValue = window.localStorage.getItem(PENDING_DETAIL_CONTEXT_LOCAL_STORAGE_KEY);
        return rawValue ? JSON.parse(rawValue) : {};
    } catch {
        return {};
    }
};

const writeStoredPendingDetailContexts = (pendingContexts: PendingDetailContextsByToken) => {
    if (!isLocalStorageSupported()) {
        return;
    }

    const tokens = Object.keys(pendingContexts);

    try {
        if (tokens.length === 0) {
            window.localStorage.removeItem(PENDING_DETAIL_CONTEXT_LOCAL_STORAGE_KEY);
            return;
        }

        window.localStorage.setItem(PENDING_DETAIL_CONTEXT_LOCAL_STORAGE_KEY, JSON.stringify(pendingContexts));
    } catch {
        return;
    }
};

const isLocalStorageSupported = () => {
    return typeof window !== "undefined" && "localStorage" in window;
};

const getUrlBase = (): string => {
    return typeof window !== "undefined" ? window.location.origin : "https://www.rynekpierwotny.pl";
};

const isAbsoluteUrl = (url: string): boolean => /^[a-z][a-z\d+\-.]*:\/\//i.test(url);
